import React from "react"
import { Button } from "reactstrap"
import { isMobile } from "react-device-detect"
import { withRouter } from "react-router"
import { userInfo, userRole } from "utils"
import { processType } from "../helper"

const ShoppingOperational = props => {
  const { processed, shoppingCartId, productLength } = props

  const renderStep1 = () => {
    return (
      <>
        <Button
          className={`mr-1 ${!isMobile && "w-25"}`}
          onClick={() => {
            props.history.push("/product")
          }}
        >
          回商品頁
        </Button>
        <Button
          style={{ color: "#FFF" }}
          color="success"
          className={`${!isMobile && "w-25"}`}
          onClick={() => props.onChangeStep(processType.STEP2)}
        >
          下一步
        </Button>
      </>
    )
  }

  const renderStep2 = () => {
    return (
      <>
        <Button
          className={`mr-1 ${!isMobile && "w-25"}`}
          onClick={() => props.onChangeStep(processType.STEP1)}
        >
          {" "}
          上一步
        </Button>
        <Button
          style={{ color: "#FFF" }}
          color="success"
          className={`${!isMobile && "w-25"}`}
          onClick={() => props.onChangeStep(processType.STEP3)}
        >
          下一步
        </Button>
      </>
    )
  }

  const renderStep3 = () => {
    return (
      <>
        <Button
          className={`mr-1 ${!isMobile && "w-25"}`}
          onClick={() => {
            props.history.push("/product")
          }}
        >
          回商品頁
        </Button>
        <Button
          className={`mr-1 ${!isMobile && "w-25"}`}
          onClick={() => {
            const { role } = userInfo()

            if (role === userRole.CUSTOMER) {
              props.history.push(`/order/detail/${shoppingCartId}`)
            } else {
              props.history.push(
                `/order/maintain-order/detail/${shoppingCartId}`
              )
            }
          }}
        >
          查詢訂單
        </Button>
      </>
    )
  }

  const renderGobackProduct = () => {
    return (
      <Button
        className={`mr-1 ${!isMobile && "w-25"}`}
        onClick={() => {
          props.history.push("/product")
        }}
      >
        回商品頁
      </Button>
    )
  }

  return (
    <div className="operational text-center">
      {processed === processType.STEP1 && productLength > 0 && renderStep1()}
      {processed === processType.STEP2 && productLength > 0 && renderStep2()}
      {processed === processType.STEP3 && renderStep3()}
      {productLength <= 0 &&
        processed !== processType.STEP3 &&
        renderGobackProduct()}
    </div>
  )
}

export default withRouter(ShoppingOperational)
